import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faEllipsisH,
  faChevronLeft,
  faChevronRight,
  faSave,
  faWallet,
  faFileInvoiceDollar
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

library.add(faEllipsisH, faChevronLeft, faChevronRight, faSave, faWallet, faFileInvoiceDollar)

export default FontAwesomeIcon
